var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container-bill-22"},[_c('video',{attrs:{"id":`testing-video-${_vm._uid}`,"autoplay":""}}),(!!_vm.error)?_c('div',{staticClass:"error-message-bill-22"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }